import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import Card from '../components/Card';
import __ from '../utils/translator';
import PatternCardList from '../components/PatternCardList';
import PageHeader from '../components/PageHeader';
import CollectionStoreActions from '../flux/CollectionStoreActions';
import CardTitle from '../components/CardTitle';
import CardProgress from '../components/CardProgress';
import ArchiveStore from "../flux/ArchiveStore";
import thronThumbnail from '../utils/thronThumbnail';
import remToPixels from '../utils/remToPixels';
import PageTitle from '../components/PageTitle';
import Header from '../components/organisms/Header';
import ThemeLabelContainer from "../components/theme-card/ThemeLabelContainer";

function resizeCover(cover) {
  return cover.replace('0x0', `${remToPixels(45)}x${remToPixels(45)}`);
}

class Archive extends Component {
  state = {
    collections: [],
  };

  subscriptions = [];

  componentDidMount() {
    CollectionStoreActions.fetchArchived();

    this.subscriptions.push(ArchiveStore.addListener(() => {
      this.setState({ collections: ArchiveStore.getState() });
    }));
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  render() {
    return (
      <div>
        <Header />

        <PageTitle withTracking title="Archive" />

        <PageHeader
          crumbs={[__('Home'), __('Seasonal')]}
          title={__('Seasonal Archive')}
          cover={thronThumbnail(this.props.theme.pageHeaderContentId.archive)} />

        <Container>
          <PatternCardList>
            {this.state.collections.map(collection => (
              <Card
                key={collection.id}
                linkTo={`seasonal/${collection.id}`}
                cover={resizeCover(collection.cover)}
                justifyContent="flex-end"
              >
                <ThemeLabelContainer
                  theme={{
                    visibleOnlyForOutlets: collection.visibleOnlyForOutlets
                  }}
                  width="40%"
                />
                <CardTitle small style={{ textTransform: 'uppercase', }}>{collection.name}</CardTitle>
                <CardProgress percentage={collection.percentage} />
              </Card>
            ))}
          </PatternCardList>
        </Container>
      </div>
    );
  }
}

export default withTheme(Archive);

const Container = styled.div``;
